import React, { useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid } from "@material-ui/core";
import Typography from "@components/Typography";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import AlertModal from "@components/PhoneModals/AlertModal";

const PopoverComponent = ({ handleClosepopOver }) => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    handleClosepopOver();
  };

  const handleClick = () => {
    history.push("/announcements/warnings");
  };

  return (
    <Grid container direction="column" spacing={10}>
      <Grid
        item
        direction="row"
        className={classes.iconContainer}
        onClick={() => setOpen(true)}
      >
        <span className={clsx("icon-plus-square", classes.icon)} />
        <Typography>{__t("New Alert")}</Typography>
      </Grid>
      <AlertModal open={open} handleClose={handleClose} />
      <Grid
        item
        direction="row"
        className={classes.iconContainer}
        onClick={handleClick}
      >
        <span className={clsx("icon-megaphone", classes.icon)} />
        <Typography>{__t("List of Alerts")}</Typography>
      </Grid>
    </Grid>
  );
};

export default PopoverComponent;
